<template>
  <div style="color: #36373f; margin-top: 63px">
    <popup :message="alertErrMessage" v-if="isAlertErr" :isError="isError" @close="isAlertErr = false" />
    <div class="hero">
      <div class="content">
        <h1>{{ $t('corporateTraining.heroSection.title') }}</h1>
        <p>{{ $t('corporateTraining.heroSection.description') }}</p>
        <div class="btn-cta">
          <button class="now" @click="scrollToSection('collab_training')">
            {{ $t('corporateTraining.heroSection.ctaButtons.collaborateNow') }}
          </button>
          <button class="call" @click="sendToWa">
            {{ $t('corporateTraining.heroSection.ctaButtons.contactUs') }}
          </button>
        </div>
      </div>
      <div class="card-img">
        <img src="/img/corporate/tech-main.png" width="520" height="" alt="" />
      </div>
    </div>

    <div class="container-fade">
      <div class="left-fade"></div>
      <div class="right-fade"></div>
    </div>
    <div class="creditbility">
      <div class="partner">
        <h1>{{ $t('corporateTraining.trustedPartners.title') }}</h1>
        <div class="card" style="overflow-x: none !important">
          <div v-for="(partner, index) in partners" :key="index">
            <div class="logo-card-partner-2">
              <img :src="partner.img_url_web" width="160" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="service">
      <div class="content">
        <h1 class="ttl">{{ $t('corporateTraining.services.title') }}</h1>
        <div>{{ $t('corporateTraining.services.description') }}</div>
      </div>
      <div class="list-service">
        <div v-for="(data, index) in $t('corporateTraining.courseOffer')" :key="index" class="data">
          <div>
            <img :src="data.img" alt="" style="width: 54px; height: 54px; border-radius: 100%">
          </div>
          <div style="display: flex; flex-direction: column; gap: 0.2rem">
            <div style="font-weight: 750; font-size: 1rem">
              {{ data.title }}
            </div>
            <div style="font-size: 0.8rem; text-align: justify">
              {{ data.desc }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="course">
      <div class="ctn">
        <h1 style="font-size: 32px; color: #36373f; margin: 0">
          {{ $t('corporateTraining.course.title') }}
        </h1>
        <div>{{ $t('corporateTraining.course.description') }}</div>
      </div>
      <v-tabs color="#575966" grow>
        <v-tab v-for="item in $t(`corporateTraining.programTabs`)" :key="item.value" :value="item.value"
          @click="chooseTab(item)" class="tab">
          {{ item.title }}
        </v-tab>
      </v-tabs>
      <v-window v-model="program">
        <v-window-item v-for="index in $t(`corporateTraining.programTabs`).length" :key="index">
          <div style="
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 20px;
            ">
            <div v-for="(data, idx) in courseMaterial" :key="idx">
              <v-card elevation="0" class="taba">
                <div class="d-flex align-center ddd">
                  <MessageIcon />
                  <div style="font-weight: 700">{{ data.title }}</div>
                </div>
                <div class="nnn">
                  <div class="sub-header text-justify" style="font-size: 14px">
                    {{ data.description }}
                  </div>
                  <div class="ccc">{{ $t('corporateTraining.course.scopeLearning') }}</div>
                  <ul style="">
                    <li v-for="(item2, idx2) in data.scope_learning" :key="idx2" style="font-size: 14px">
                      {{ item2.name }}
                    </li>
                  </ul>
                </div>
              </v-card>
            </div>
          </div>
        </v-window-item>
      </v-window>
      <v-card elevation="0" class="card-box-info">
        <v-row style="padding: 40px">
          <v-col cols="8">
            <div class="data1">{{ $t('corporateTraining.course.cta.notFound') }}</div>
            <div v-html="$t('corporateTraining.course.cta.consultation')"></div>
          </v-col>
          <v-col cols="4" class="ctn-konsultasi" @click="sendToWaConsultation">
            <v-btn class="btnn" elevation="0" style="text-transform: none;">{{ $t('corporateTraining.course.cta.button')
            }}</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div style="padding: 60px">
      <v-row>
        <v-col cols="6" style="padding-left: 46px">
          <div style="padding-right: 20px">
            <div style="font-size: 28px; font-weight: 700">{{ $t('corporateTraining.whyChoose2.title') }}</div>
            <div style="margin-top: 12px" v-html="$t('corporateTraining.whyChoose2.description')"></div>
          </div>
          <div style="
              margin-top: 80px;
              width: 90%;
              height: 60%;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
            <img src="/img/corporate/tech/main-2.png" width="100%" />
          </div>
        </v-col>
        <v-col cols="6" style="padding-left: 20px">
          <v-col v-for="(data, index) in $t(`corporateTraining.whyChoose`)" :key="index">
            <v-row>
              <div style="padding-top: 18px; margin-right: 8px">
                <img :src="`/img/corporate/w-${index + 1}.png`" alt="aaa"
                  style="width: 42px; height: 42px;border-radius: 100%; ">
              </div>
              <v-col cols="10">
                <div style="
                    font-size: 18px;
                    font-weight: 700;
                    margin-top: 8px;
                    margin-bottom: 6px;
                  ">
                  {{ data.title }}
                </div>
                <div class="sub-heading" style="font-size: 13px">
                  {{ data.desc }}
                </div>
              </v-col>
              <div style="
                  border-bottom: 1px #d3d6e1 solid;
                  width: 100%;
                  padding-top: 10px;
                  margin-top: 10px;
                  margin-bottom: 20px;
                " v-if="index != 5"></div>
            </v-row>
          </v-col>
        </v-col>
      </v-row>
      <StepCollaboration :title="$t(`corporateTraining.a1`)" :steps="$t(`corporateTraining.steps`)" />
      <Partner :title="$t(`corporateTraining.a2`)" :partners="dataMitra" />
      <portofolio :title="$t(`corporateTraining.a3`)" :portfolios="portfolios" />
      <Testimony :title="$t(`corporateTraining.a4`)" :testimonies="testimony" />

      <div class="form-konsultasi" id="collab_training">
        <div class="header text-center">
          <h1>{{ $t('corporateTraining.formSection.title') }}</h1>
        </div>

        <div class="sub-heading text-center" style="margin-top: -30px">
          <p>{{ $t('corporateTraining.formSection.subTitle') }}</p>
        </div>

        <v-form class="text-start" style="margin-top: 60px">
          <v-row>
            <v-col cols="6">
              <label class="form-label" for="company">
                {{ $t('corporateTraining.formSection.labels.companyName') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field class="form-input text-form" name="company" v-model="form.corporate_name" outlined
                :placeholder="$t('corporateTraining.formSection.placeholders.companyName')"></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="website">
                {{ $t('corporateTraining.formSection.labels.website') }}
              </label>
              <v-text-field class="form-input text-form" name="website" v-model="form.web_url" outlined
                :placeholder="$t('corporateTraining.formSection.placeholders.website')"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <label class="form-label" for="pic-name">
                {{ $t('corporateTraining.formSection.labels.picName') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field class="form-input text-form" name="pic-name" v-model="form.full_name" outlined
                :placeholder="$t('corporateTraining.formSection.placeholders.picName')"></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="occupation">
                {{ $t('corporateTraining.formSection.labels.occupation') }}
              </label>
              <v-text-field class="form-input text-form" name="occupation" v-model="form.job_pic" outlined
                :placeholder="$t('corporateTraining.formSection.placeholders.occupation')"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <label class="form-label" for="email">
                {{ $t('corporateTraining.formSection.labels.email') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field class="form-input text-form" name="email" v-model="form.email" outlined
                :placeholder="$t('corporateTraining.formSection.placeholders.email')"></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="phone-number">
                {{ $t('corporateTraining.formSection.labels.phoneNumber') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field class="form-input text-form" name="phone-number" outlined
                :placeholder="$t('corporateTraining.formSection.placeholders.phoneNumber')" type="number"
                v-model="form.phone_number" hide-spin-buttons>
                <template v-slot:prepend-inner>
                  <v-row class="d-flex align-center mt-0 ml-7">
                    <img src="/img/other/flag-indonesia.png" alt="" width="30" height="20"
                      style="box-shadow: 2px 2px 3px 1px rgba(13, 28, 113, 0.1)" />
                    <span style="color: #575966" class="mx-3">+62</span>
                  </v-row>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="form-collab">
              <label class="form-label" for="collaboration">
                {{ $t('corporateTraining.formSection.labels.collaborationType') }}
              </label>
              <v-text-field class="form-input text-form" solo flat background-color="rgba(247, 249, 253, 1)"
                :placeholder="$t('corporateTraining.formSection.placeholders.collaborationType')"
                disabled></v-text-field>
            </v-col>
          </v-row>

          <v-row style="margin-bottom: -30px">
            <v-col cols="6">
              <label class="form-label">
                {{ $t('corporateTraining.formSection.labels.category') }}
                <span style="color: #c63c38">*</span>
              </label>
              <v-select flat outlined color="#ACAFBF" persistent-hint
                :placeholder="$t('corporateTraining.formSection.placeholders.category')" v-model="program"
                :items="$t('corporateTraining.courseOffer')" :item-text="'title'" :item-value="'value'"
                @change="getCourseMaterial" style="margin-top: 10px"></v-select>
            </v-col>
            <v-col cols="6">
              <label class="form-label">
                {{ $t('corporateTraining.formSection.labels.program') }}
                <span style="color: #c63c38">*</span>
              </label>
              <v-text-field class="form-input text-form" v-model="form.program" outlined
                :placeholder="$t('corporateTraining.formSection.placeholders.program')"></v-text-field>
              <!-- <v-select flat outlined color="#ACAFBF" persistent-hint
                :placeholder="$t('corporateTraining.formSection.placeholders.program')" v-model="form.program"
                :items="courseMaterial" :item-text="'title'" :item-value="'title'" style="margin-top: 10px"></v-select> -->
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center align-center mt-3">
            <v-checkbox class="form-input custom-checkbox" v-model="is_confirm">
              <template v-slot:label>
                <p class="label-checkbox" v-html="`${$t('corporateTraining.formSection.labels.confirmCheckbox')}`"></p>
              </template>
            </v-checkbox>
          </v-row>

          <v-row class="d-flex justify-center align-center mt-6">
            <v-btn elevation="0" :class="`btn-kirim ${is_confirm ? 'confirm' : 'reject'}`" @click="onSubmit">
              {{ $t('corporateTraining.formSection.buttons.submit') }}
            </v-btn>
          </v-row>
        </v-form>
      </div>
    </div>
    <div class="faq" style="margin-top: 60px">
      <div class="content">
        <div class="row">
          <div class="col-lg-3">
            <div class="header">
              <h1>Frequently Asked Question</h1>
            </div>
          </div>
          <div class="col-lg-9" style="margin-top: 10px">
            <v-expansion-panels flat class="faq-card" style="background-color: #F1F6FF;">
              <v-expansion-panel v-for="(item, index) in questions" :key="index"
                style="border-radius: 20px; padding: 0; margin-bottom: 10px;">
                <v-expansion-panel-header disable-icon-rotate @click="openFaq(index, item.title)">
                  <h2 style="margin: 25px 0; font-size: 18px;">{{ item.title }}</h2>
                  <template v-slot:actions>
                    <div class="icon" v-if="item.active">
                      <ArrowIcon />
                    </div>
                    <div v-else>
                      <ArrowIcon :down="!item.active" />
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="item.description"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div style="margin-left: 10px">
              <div class="btn-stoke-blue" @click="goToFaq">
                <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
                <ArrowLong />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import Components
import ArrowIcon from "@/assets/icons/Arrow.vue";
import StepCollaboration from "../../StepCollaboration.vue";
import Testimony from "../../Testimony.vue";
import Portofolio from "../../Portofolio.vue";
import Partner from "../../Partner.vue";
import Popup from "@/components/others/Popup.vue";
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import MessageIcon from "@/components/ilustration/MessageIcon.vue";

export default {
  name: "CorporateTraining",
  components: {
    ArrowIcon,
    StepCollaboration,
    Testimony,
    Portofolio,
    Partner,
    Popup,
    MessageIcon,
    ArrowLong
  },
  data() {
    return {
      generalTraining: true,
      certifiedTraining: false,
      program: 0,
      courseMaterial: [],
      portfolios: [],
      testimony: [],
      questions: [],
      partners: [],
      dataMitra: [],
      alertErrMessage: "",
      isAlertErr: false,
      is_confirm: false,
      isError: false,
      form: {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        corporate_name: "",
        company_field: "",
        program: "",
        total_student: 0,
        notes: "",
        category: "TRAINING",
        web_url: "",
        job_pic: "",
      },
    };
  },
  watch: {
    program() {
      this.getCourseMaterial();
    },
    "$i18n.locale"() {
      this.getTestimoni();
      this.getMitra();
      this.getCourseMaterial();
      this.getPortofolio();
      this.getFaq();
    },
  },
  methods: {
    chooseTab(item) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Select Program Tab - ${item.title} - Pelatihan Karyawan`,
        value: 1,
      });
      this.program = item.value;
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get("/v1/logo?category=TRAINING");
        this.partners = resp.data.data.logos;
        this.duptlicatePartners();
      } catch (err) {
        console.log(err);
      }
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(
          `/v1/testimony?category=TRAINING&page=1&per_page=9`
        );
        this.testimony = resp.data.data.testimonies;
        while (this.testimony.length % 3 !== 0) {
          this.testimony.push("");
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getMitra() {
      try {
        const resp = await this.$http.get(
          `/v1/partner?category=TRAINING&page=1&per_page=9`
        );
        this.dataMitra = resp.data.data.partners;
      } catch (err) {
        console.log(err);
      }
    },
    async getCourseMaterial() {
      try {
        const resp = await this.$http.get(
          `/v1/corporate-training?category=${this.program ? "CERTIFIED" : "GENERAL"}`
        );
        this.courseMaterial = resp.data.data.corporate_trainings;
        this.form.program = "";
      } catch (error) {
        console.log(error);
      }
    },
    async getPortofolio() {
      try {
        const resp = await this.$http.get(
          `/v1/project-portfolio?category=TRAINING&is_main=true`
        );
        this.portfolios = resp.data.data.project_portfolios;
      } catch (err) {
        console.log(err);
      }
    },
    duptlicatePartners() {
      this.partners = this.partners.concat(
        this.partners,
        this.partners,
        this.partners
      );
    },
    openFaq(idx, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Open FAQ - ${title} - Pelatihan Karyawan`,
        value: 1,
      });
      const valDef = this.questions[idx].active;
      this.questions.forEach((e) => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(
          `/v1/faq?category=TRAINING&is_main=true`
        );
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp - Pelatihan Karyawan',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    sendToWaConsultation() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Consultation - WhatsApp - Pelatihan Karyawan',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToSection(sectionId) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Collaborate Now - Scroll to Form - Pelatihan Karyawan',
        value: 1,
      });
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - Pelatihan Karyawan',
        value: 1,
      });
      this.$router.push('/faq');
    },
    async onSubmit() {
      this.$gtag.event('click', {
        event_category: 'Form',
        event_label: 'Submit Pelatihan Karyawan Form',
        value: 1,
      });
      if (!this.is_confirm) {
        return;
      }
      if (
        !this.form.corporate_name ||
        !this.form.full_name ||
        !this.form.job_pic ||
        !this.form.email ||
        !this.form.phone_number ||
        !this.form.category ||
        !this.form.web_url ||
        !this.form.program
      ) {
        this.alertErrMessage = "Harap isi semua form yang tersedia";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Pelatihan Karyawan Form Submission Error',
          value: 0,
        });
        return;
      }
      try {
        await this.$http.post("/v1/corporate-registration", this.form);
        this.alertErrMessage = "Success";
        this.isAlertErr = true;
        this.isError = false;
        this.clearForm();
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Pelatihan Karyawan Form Submission Success',
          value: 1,
        });
      } catch {
        this.alertErrMessage = "Error saat submit data";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Pelatihan Karyawan Form Submission Error',
          value: 0,
        });
      }
    },
    clearForm() {
      this.is_confirm = false;
      this.form.full_name = "";
      this.form.email = "";
      this.form.phone_number = "";
      this.form.corporate_name = "";
      this.form.category = "";
      this.form.web_url = "";
      this.form.job_pic = "";
      this.form.program = "";
      this.notes = "";
      this.program = "";
    },
  },
  mounted() {
    this.getFaq();
    this.getTestimoni();
    this.getClientLogo();
    this.getCourseMaterial();
    this.getPortofolio();
    this.getMitra();
  },
};
</script>

<style src="./corporateTraining.css" scoped></style>